import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import { useGlobalSettings } from '../contexts/GlobalSettingsContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiExternalLink, FiCode, FiNavigation } = FiIcons;

const VenueCard = ({ venue }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { settings } = useGlobalSettings();

  const PRODUCTION_URL = settings.productionUrl || 'https://site2rent.netlify.app';
  const widgetCode = `<iframe src="${PRODUCTION_URL}/#/widget/${user?.id}/${venue.id}" width="400" height="600" frameborder="0"></iframe>`;

  const copyWidgetCode = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(widgetCode);
    alert('Codul widget-ului a fost copiat!');
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-all group"
      onClick={() => navigate(`/venue/${venue.id}`)}
    >
      <div className="relative h-48">
        <img 
          src={venue.photos?.[0] || 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800'} 
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" 
          alt={venue.name} 
        />
        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur px-3 py-1 rounded-lg text-sm font-bold text-blue-600 shadow-sm">
          €{venue.price_per_night}/noapte
        </div>
        {venue.is_promoted && (
          <div className="absolute top-4 left-4 bg-yellow-400 text-yellow-900 px-2 py-1 rounded-md text-[10px] font-black tracking-tighter uppercase">
            Promovat
          </div>
        )}
      </div>

      <div className="p-5">
        <h3 className="text-lg font-bold text-gray-900 truncate mb-1">{venue.name}</h3>
        
        <div className="flex items-center text-gray-500 text-xs mb-4">
          <SafeIcon icon={FiMapPin} className="mr-1 h-3 w-3" />
          <span className="truncate">{venue.address}</span>
        </div>

        <div className="flex gap-2">
          <button 
            onClick={(e) => { e.stopPropagation(); navigate(`/venue/${venue.id}`); }}
            className="flex-1 bg-blue-600 text-white py-2 rounded-lg text-xs font-bold hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
          >
            <SafeIcon icon={FiExternalLink} /> Administrează
          </button>
          <button 
            onClick={copyWidgetCode}
            className="p-2 bg-gray-50 text-gray-400 hover:text-blue-600 hover:bg-blue-50 border border-gray-100 rounded-lg transition-all"
            title="Copiază codul widget"
          >
            <SafeIcon icon={FiCode} />
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default VenueCard;